import { render, staticRenderFns } from "./ProfessionalInfoFragment.vue?vue&type=template&id=9f6ac68e"
import script from "./ProfessionalInfoFragment.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfoFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports